import { TipoContrato } from '../models/tipo-contrato.interface';

export interface TipoContratoState {
  tiposContrato: TipoContrato[];
  selectedTipoContrato: TipoContrato | null;
  loading: boolean;
  error: string | null;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
  searchResults: TipoContrato[];
  searchQuery: string;
}

export const initialTipoContratoState: TipoContratoState = {
  tiposContrato: [],
  selectedTipoContrato: null,
  loading: false,
  error: null,
  creating: false,
  updating: false,
  deleting: false,
  searchResults: [],
  searchQuery: ''
};
